"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _DropdownMixin = require("./DropdownMixin");
/** @class MenuMixin */
/**
 * Styles for the `Menu` component.
 *
 * @example
 * import { MenuMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${MenuMixin}
 * `;
 *
 * <Component />
 *
 * @method
 * @param {object} props
 * @param {object} props.theme
 * @return {CSSObject}
 */
var MenuMixin = function MenuMixin(props) {
  return (0, _styledToken.default)({
    minWidth: 'Dialog.minWidth',
    maxWidth: 'Dialog.maxWidth'
  }, function (_ref) {
    var minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth;
    return (0, _styledComponents.css)(["", " min-width:", "px;max-width:", "px;"], (0, _DropdownMixin.DropdownMixin)(props), minWidth, maxWidth);
  })(props);
};
exports.MenuMixin = MenuMixin;